import AppCard from "./AppCard/index.vue";
import AppIcon from "./AppIcon/index.vue";
import AppFile from "./AppFile/index.vue";
import AppFormAlert from "./AppFormAlert/index.vue";
import AppFormSubmit from "./AppFormSubmit/index.vue";
import AppLabel from "./AppLabel/index.vue";
import AppList from "./AppList/index.vue";
import AppMasker from "./AppMasker/index.vue";
import AppPagination from "./AppPagination/index.vue";
import AppQiniu from "./AppQiniu/index.vue";
import AppQueryName from "./AppQueryName/index.vue";
import TheHeader from "./TheHeader/index.vue";
import TheFooter from "./TheFooter/index.vue";
import VRadioText from "./VRadioText/index.vue";
import AppTextArea from "./AppTextArea/index.vue";
import FileDialog from "./AppMaterial/FileDialog.vue";

const components = {
  AppCard,
  AppIcon,
  AppFile,
  AppFormAlert,
  AppFormSubmit,
  AppLabel,
  AppList,
  AppMasker,
  AppPagination,
  AppQiniu,
  AppQueryName,
  TheHeader,
  TheFooter,
  VRadioText,
  AppTextArea,
  FileDialog,
};

export default Vue => Object.keys(components)
    .forEach(key => Vue.component(key, components[key]));
